import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ({ items, testIdPrefix = "faq" }) {
    return (
        <Accordion type="single" collapsible className="w-full" data-testid={`${testIdPrefix}-root`}>
            {items.map((it, i) => (
                <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    className="border-border"
                    data-testid={`${testIdPrefix}-item-${i}`}
                >
                    <AccordionTrigger
                        data-testid={`${testIdPrefix}-trigger-${i}`}
                        className="py-6 text-left text-lg md:text-xl font-heading font-medium hover:text-brand hover:no-underline"
                    >
                        {it.q}
                    </AccordionTrigger>
                    <AccordionContent
                        data-testid={`${testIdPrefix}-content-${i}`}
                        className="pb-6 text-base md:text-lg leading-relaxed text-ink-soft"
                    >
                        {it.a}
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );
}
